import React, { Component } from "react";
import Keycloak from 'keycloak-js';
import { Link } from "react-router-dom";
import { Button, Card, Col, Container, Image, Row, Form } from "react-bootstrap";

import AuthenticationModal from "./MaenadaAuthenticationModalIssuer";

export type PotentialLandingIssuerState = {
  validated?: boolean;
  showAuthenticationModal?: boolean;
  payload?: any;
  authenticated?: boolean;
  token?: string;
  tokenOffer?: string;
  offerUrl?: string;
  offerId?: string;
  credentialTypes?: any[];
  credentialType?: string;
  flow?: string;
  credentialIdentification?: string;
  urlScheme?: string;
  claim_familyName?: string;
  claim_givenName?: string;
  claim_dateOfBirth: string;
  claim_address?: string;
  claim_placeOfBirth?: string;
  claim_issuanceDate: string;
  claim_expiryDate: string;
  claim_issuingAuthority?: string;
  claim_issuingCountry?: string;
};

export type PotentialLandingIssuerProps = {

};

export default class PotentialLandingIssuer extends Component<PotentialLandingIssuerProps, PotentialLandingIssuerState> {
  state: PotentialLandingIssuerState = {
    claim_dateOfBirth: "1990-06-01",
    claim_issuanceDate: "2020-06-01",
    claim_expiryDate: "2030-06-01"
  };
  apiUrl = "https://dev-integration-ssi-agents.fra.nip-non-prod.cloud.netcetera.com";

  componentDidMount(): void {
    this.setState({
      validated: false,
      showAuthenticationModal: false,
      payload: undefined,
      authenticated: false,
      token: undefined,
      tokenOffer: undefined,
      offerUrl: "",
      offerId: "",
      credentialTypes: [{id: "PID", displayName: "PID Credential"}],
      credentialType: "PID",
      flow: "authCodeFlow",
      credentialIdentification: "scope",
      urlScheme: "haip://",
      claim_familyName: "",
      claim_givenName: "",
      claim_dateOfBirth: "1990-06-01",
      claim_address: "",
      claim_placeOfBirth: "",
      claim_issuanceDate: "2020-06-01",
      claim_expiryDate: "2030-06-01",
      claim_issuingAuthority: "",
      claim_issuingCountry: ""
    });

    this.loadCredentials();

    this.getToken();
    
  } 

  async loadCredentials(){
    let response = await fetch(this.apiUrl + "/.well-known/openid-credential-issuer", {
      method: "GET",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      }
    });
    let credentialsResponse = await response.json();
    let credentials: any[] = [];
    Object.keys(credentialsResponse.credential_configurations_supported).forEach((key, index) => {
      credentials.push({
        id: key,
        displayName: credentialsResponse.credential_configurations_supported[key].display[0].name
      });
    })
    this.setState({credentialTypes: credentials})
  }

  calculateAge(birthday: Date) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
 }

 isOver18(){
  if (this.state.claim_dateOfBirth){
    return this.calculateAge(new Date(Date.parse(this.state.claim_dateOfBirth))) >= 18;
  }
  return false;
 }

 async getToken(){
  const formData = new FormData();
  formData.append("grant_type", "client_credentials")
  let response = await fetch(this.apiUrl + "/oauth2/token", {
    method: "POST",
    mode: 'cors',
    headers: {
      Accept: "*/*",
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic c2FtcGxlQ2xpZW50OmNsSWkzI3kwQG5IITE="
    },
    body: "grant_type=client_credentials"
  });

  let token = await response.json();
  this.setState({tokenOffer: token.access_token});
 }

  async generateOffer(){
    let dateOfBirth = new Date(Date.parse(this.state.claim_dateOfBirth));
    let dateOfBirthFormatted = dateOfBirth.getDay() + "-" + dateOfBirth.getMonth() + "-" + dateOfBirth.getFullYear();

    let body: any = {
      authorizationCodeFlow: {
        includeIssuerState: true
      },
      credentials: [
        {
          type: this.state.credentialType,
          claims: {
            given_name: this.state.claim_givenName,
            family_name: this.state.claim_familyName,
            birthdate: dateOfBirthFormatted,
            address: {
              formatted: this.state.claim_address
            },
            age_equal_or_over: {
              "18": this.isOver18()
            },
            place_of_birth: {
              locality: this.state.claim_placeOfBirth
            },
            iat: Math.round(new Date(Date.parse(this.state.claim_issuanceDate)).getTime() / 1000), 
            exp: Math.round(new Date(Date.parse(this.state.claim_expiryDate)).getTime() / 1000), 
            issuing_authority: this.state.claim_issuingAuthority,
            issuing_country: this.state.claim_issuingCountry
          }
        }
        
      ],
      urlScheme: this.state.urlScheme
    };
    let response = await fetch(this.apiUrl + "/openid4vci/offers", {
      method: "POST",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + this.state.tokenOffer
      },
      body: JSON.stringify(body)
    });

    let offer = await response.json();
    this.setState({offerUrl: offer.urlRepresentation});
    this.setState({offerId: offer.expandedRepresentation.transaction_uuid});
    console.log(offer.urlRepresentation);

    this.showLoginDialog();
  }

  handleSubmit(thisObj: any, event: any){
    event.preventDefault();
    //event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      return;
    }
    thisObj.setState({validated: true});
    thisObj.generateOffer();
  };

  render() {
    if (!this.state.authenticated) return null;
    return (
      <div
        style={{
          width: "100%",
          // backgroundImage: "url('https://st.depositphotos.com/13400724/54064/v/450/depositphotos_540644508-stock-illustration-monochrome-simple-geometric-effect-background.jpg')", // TODO: Change background image if needed
          // backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
        }}
      >
        <Form validated={this.state.validated} onSubmit={(event) => this.handleSubmit(this, event)}>
          <Container style={{ height: "80vh" }}>
            <Container className="mt-5">
              <h1 style={{ textShadow: "1px 1px 2px white" }}>
                Simple Issuer UI
              </h1>
            </Container>
            <Row style={{ marginTop: "150px" }}>
              <Col>
                
                  <Container className="mt-5">
                    <Row><Col><h4>Credential</h4></Col><Col>
                    <Form.Control required as="select" name="credentialType" value={this.state.credentialType} onChange={(e) => this.setState({credentialType: e.target.value})} >
                      {
                        this.state.credentialTypes?.map(function (cred) {
                            return <option key={cred.id} value={cred.id} >{cred.displayName}</option>
                        })
                    }
                    </Form.Control>
                    </Col></Row>
                    <Row style={{ marginTop: "50px" }}><Col style={{ marginLeft: "-30px" }}><h4>Claims</h4></Col></Row>
                    <Row style={{ marginTop: "10px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Family Name</Col><Col><Form.Control required type="input" name="familyName" value={this.state.claim_familyName} onChange={(e) => this.setState({claim_familyName: e.target.value})} /></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Given Name</Col><Col><Form.Control required type="input" name="givenName" value={this.state.claim_givenName} onChange={(e) => this.setState({claim_givenName: e.target.value})} /></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Date of Birth</Col><Col><Form.Control required type="date" name="dateOfBirth" value={this.state.claim_dateOfBirth} onChange={(e) => this.setState({claim_dateOfBirth: e.target.value})} /></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Age Equal or Over 18</Col><Col><Form.Check type="switch" name="over18" checked={this.isOver18()} disabled={true} /></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Address</Col><Col><Form.Control required type="textarea" name="address" value={this.state.claim_address} onChange={(e) => this.setState({claim_address: e.target.value})} /></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Place of Birth</Col><Col><Form.Control required type="input" name="placeOfBirth" value={this.state.claim_placeOfBirth} onChange={(e) => this.setState({claim_placeOfBirth: e.target.value})}/></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Issuance Date</Col><Col><Form.Control required type="date" name="issuanceDate" value={this.state.claim_issuanceDate} onChange={(e) => this.setState({claim_issuanceDate: e.target.value})}/></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Expiry Date</Col><Col><Form.Control required type="date" name="expiryDate" value={this.state.claim_expiryDate} onChange={(e) => this.setState({claim_expiryDate: e.target.value})}/></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Issuing Authority</Col><Col><Form.Control required type="input" name="issuingAuthority" value={this.state.claim_issuingAuthority} onChange={(e) => this.setState({claim_issuingAuthority: e.target.value})}/></Col></Row>
                    <Row style={{ marginTop: "5px" }}><Col><span style={{color: "red"}}>*&nbsp;</span>Issuing Country</Col><Col><Form.Control required type="input" name="issuingCountry" value={this.state.claim_issuingCountry} onChange={(e) => this.setState({claim_issuingCountry: e.target.value})}/></Col></Row>
                  </Container>
                
              </Col>
              <Col>
              <Container className="mt-5">
                  <Row><Col style={{ marginLeft: "-30px" }}><h4>Flows</h4></Col></Row>
                  <Row ><Col>Flow</Col><Col>
                  <Form.Control as="select" name="flow" value={this.state.flow} onChange={(e) => this.setState({flow: e.target.value})} >
                    <option id="authCodeFlow">Authorization Code Flow</option>
                  </Form.Control>
                  </Col></Row>
                  <Row style={{ marginTop: "5px" }}><Col>Credential Identification</Col><Col>Scope</Col></Row>
                  <Row style={{ marginTop: "50px" }}><Col>Url scheme</Col><Col><Form.Control type="input" name="urlScheme" value={this.state.urlScheme} onChange={(e) => this.setState({urlScheme: e.target.value})} /></Col></Row>
                  <Row style={{ marginTop: "50px" }}><Col><Button type="submit" className="pull-right" name="btnGenerateOffer" variant="primary">Generate Offer</Button></Col></Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </Form>
        <AuthenticationModal
              show={this.state.showAuthenticationModal as boolean}
              onCloseClicked={this.hideLoginDialog}
              token={this.state.tokenOffer}
              urlRepresentation={this.state.offerUrl}
              offerId={this.state.offerId}
              title={this.getCredDisplayText()}
              onSignInComplete={this.completeSignIn} />
      </div>
    );
  }

  private getCredDisplayText(){
    let selectedItems = this.state.credentialTypes?.filter(cred => cred.id === this.state.credentialType);
    if (selectedItems?.length === 1){
      return selectedItems[0].displayName;
    }
    return "empty";
  }

  private hideLoginDialog = () => {
    this.setState({ showAuthenticationModal: false });
  };

  private showLoginDialog = () => {
    this.setState({ showAuthenticationModal: true });
  };

  private completeSignIn = (payload: any) => {
    this.setState({ showAuthenticationModal: false, payload });
  };
}
